// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"48f8ab77","513":"210815da","703":"30ef1a8b"}[chunkId] + ".chunk.js";
};